import { UploadImage, GetPendingImages, MarkAsCompleted, GetProductImageSavedData } from "./../../../../../actions/ProductActions";
import { GET_ERRORS, MARK_AS_COMPLETED, UPLOAD_IMAGE, UPLOAD_FILE, PRODUCT_IMAGE_SAVED } from "../../../../../actions/types";
import ToolkitProvider, { Search, CSVExport } from 'react-bootstrap-table2-toolkit';
import { SearchOutlined, Refresh, Info } from "@material-ui/icons";
import BootstrapTable from 'react-bootstrap-table-next';
import LoadingOverlay from 'react-loading-overlay';
import 'react-widgets/dist/css/react-widgets.css';
import 'react-dropzone-uploader/dist/styles.css';
import ImageAuditModal from "../ImageAuditModal";
import Dropzone from 'react-dropzone-uploader';
import { Col, Row } from "react-bootstrap";
import { IconButton } from "material-ui";
import React, { Component } from "react";
import { connect } from "react-redux";
import "./UploadProductImage.scss";
import "../../MainContent.scss";
// Snack bar
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';

function Alert(props) {
	return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const { SearchBar } = Search;
const columnsUpload = [
	{
		dataField: 'no_sap',
		text: 'No Sap'
	},
	{
		dataField: 'message',
		text: 'Mensaje'
	}
];


function customMatchFunc({ searchText, value, column, row }) {
	if (typeof value !== 'undefined') {
		return value.startsWith(searchText);
	}
	return false;
}

class UploadProductImage extends Component {

	//----------------------INIT-----------------//

	state = {
		imageAuditModalIsVisible: false,
		resolution900x900:        true,
		activeLoader:             true,
		showSnackBar:             false,
		severitySnackBar:         'success',
		textSnackBar:             '',
		totalPendingImagesPages:  0,
		limit:                    25,
		page:                     1,
		pendingImages:            [],
		productImageSavedData:    null,
	}

	constructor(props) {
		super(props);
		this.handleCancel = this.handleCancel.bind(this);
	}

	componentDidMount() {
		this.props.product_reducer.imageCompleted = null;
		this.onDownloadReport                     = this.onDownloadReport.bind(this);
		this.onSearch                             = this.onSearch.bind(this);
		this.onRefresh                            = this.onRefresh.bind(this);
		this.getImages();
	}

	componentDidUpdate(prev) {
		if (this.props.pendingImages !== this.state.pendingImages) {
			this.setState({
				pendingImages: this.props.pendingImages,
				totalPendingImagesPages: this.props.totalPendingImagesPages,
				activeLoader: false
			});
		} else if (this.props.actionType === UPLOAD_IMAGE && prev.actionType !== UPLOAD_IMAGE) {
			this.getImages();
		} else if (this.props.actionType === UPLOAD_FILE && prev.actionType !== UPLOAD_FILE) {
			this.getImages();
		} else if (this.props.actionType === GET_ERRORS && prev.actionType !== GET_ERRORS) {
			this.setState({
				activeLoader: false,
				showSnackBar: true,
				textSnackBar: JSON.stringify(this.props.product_reducer.message),
				severitySnackBar: 'error',
			});
		} else if (this.props.actionType === MARK_AS_COMPLETED && this.props.product_reducer.imageCompleted !== null) {
			const message = this.props.product_reducer.imageCompleted
			this.setState({
				showSnackBar: true,
				textSnackBar: message,
				severitySnackBar: 'success',
			}, () => {
				this.getImages();
				this.props.product_reducer.imageCompleted = null;
			});
		} else if (this.props.actionType === PRODUCT_IMAGE_SAVED && prev.actionType !== PRODUCT_IMAGE_SAVED) {
			if (this.state.productImageSavedData === null) {
				this.getProductImageData(this.props.product_reducer.productImageSavedData.no_sap, this.props.product_reducer.productImageSavedData);
			}
		}
	}

	//----------------------EVENTS-----------------//

	onDownloadReport() {
		let resolution = "900x900";
		if (!this.state.resolution900x900)
			resolution = "300x300";

		const url = process.env.REACT_APP_API_URL + "/v2/products/download-csv-pending-images-products?resolution=" + resolution;
		window.open(url, '_blank');

	}

	getUploadParams = ({ meta }) => {
		return {
			url: 'https://httpbin.org/post'
		}
	}

	handleSubmit = async (files, allFiles) => {
		let resolution = "900x900";
		if (!this.state.resolution900x900) {
			resolution = "300x300";
		}
		this.setState({
			activeLoader: true
		});
		let imageData = {
			images:     [],
			resolution: resolution,
			user_id:    localStorage.getItem('user_id')
		};
		for (const f of allFiles) {
			let data    = {}
			data.name   = f.file.name;
			data.base64 = await this.blobToBase64(f.file);
			imageData.images.push(data);
			f.remove();
		}
		if (imageData.images.length > 0) {
			await this.props.UploadImage(imageData);
		} else {
			this.setState({
				showSnackBar:     true,
				textSnackBar:     'Por favor seleccione imagenes válidas para cargar.',
				severitySnackBar: 'error',
				activeLoader:     false
			});
		}
	}

	handleCancel() {
		this.setState({
			imageAuditModalIsVisible: false,
			productImageSavedData:    null
		});
		this.getImages();
	}

	blobToBase64(blob) {
		return new Promise((resolve, reject) => {
			let reader = new FileReader();
			reader.readAsDataURL(blob);
			reader.onloadend = () => {
				resolve(reader.result.split(',')[1]);
			}
		});
	}

	onMarkAsCompleted(no_sap) {
		this.setState({
			activeLoader: true
		});

		let resolution = "900x900";
		if (!this.state.resolution900x900)
			resolution = "300x300";

		this.props.MarkAsCompleted(no_sap, resolution);
	}

	linkActions = (cell, row, rowIndex, formatExtraData) => {
		return ([
			<Row key={rowIndex}>
				<Col key={rowIndex} xs={12} md={12} sm={12} lg={12}>
					<IconButton key={rowIndex} size="small" style={{color:"orange"}}>
						<Info
							key={rowIndex}
							onClick={() => { this.getProductImageData(row.no_sap); }}
						>
						</Info>
					</IconButton>
					<p>Auditar</p>
				</Col>
			</Row>
		]);
	};

	getProductImageData(noSap, data) {
		if (data === undefined) {
			this.props.GetProductImageSavedData(noSap); 
		} else {
			this.setState({
				imageAuditModalIsVisible: !this.state.imageAuditModalIsVisible,
				productImageSavedData:    data
			});
		}
	}

	handleResolution(resolutionFlag) {
		this.setState({
			resolution900x900: resolutionFlag,
			page: 1
		}, () => {
			this.getImages();
		});
	}

	getImages(sap = null, page = null) {
		let newState = {
			activeLoader: true,
		};
		if (page)
			newState.page = page;
		this.setState(newState,
			() => {
				let resolution = "900x900";
				if (!this.state.resolution900x900) {
					resolution = "300x300";
					this.props.GetPendingImages(resolution, this.state.limit, this.state.page, sap);
				}
				else
					this.props.GetPendingImages(resolution, this.state.limit, this.state.page, sap);
			});
	}

	onSearch() {
		const noSap = document.getElementById("search-bar-0").value;
		if (noSap !== "")
			this.getImages(noSap, 1);
	}

	onRefresh() {
		this.getImages(null);
	}


	handleCloseSnack = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		this.setState({
			showSnackBar: false
		})
	}

	//----------------------VIEW-----------------//
	render() {
		const rowStyle = (row, rowIndex) => {
			return { backgroundColor: row.code === 200 ? '#33FF41 ' : '#FF3336' };
		};
		const columnsPending = [
			{
				dataField: 'no_sap',
				text: 'No Sap'
			},
			{
				dataField: 'not_in_s3',
				text: 'Faltantes',
				formatter: (cell) => {
					let text = ""
					if (cell) {
						for (let i = 0; i < cell.length; i++) {
							const c = cell[i]
							if (i !== 0) {
								text = text + ", " + c
							} else {
								text = c
							}
						}
					}
					return text
				}
			},
			{
				dataField: "actions",
				text: "Acciones",
				formatter: this.linkActions,
			}
			/*{
				dataField: "actions",
				text: "Marcar como completada.",
				headerStyle: () => {
					return { width: "15%" };
				},
				formatter: this.linkActions,
				csvExport: false
			}*/
		];

		let data = [];
		const { product_reducer } = this.props;
		if (!product_reducer || !product_reducer.data) {
			product_reducer.data = [];
		}
		data = product_reducer.data
		for (let i = 0; i < this.state.pendingImages.length; i++) {
			this.state.pendingImages[i].row_number = i;
		}

		return (
			<div className="col-md-12">
				<Col xs={12} md={12} sm={12} lg={12}>
					<h4 style={{ color: '#164289', 'fontWeight': 'bold', marginTop: '5px' }}>Tamaño de imagenes</h4>
					<div>
						<input
							type="radio"
							style={{ cursor: 'pointer' }}
							checked={this.state.resolution900x900}
							onChange={() => { this.handleResolution(true) }} />
						<span style={{ color: '#164289', fontSize: '1.2rem' }}> 900 x 900</span>
						&nbsp;&nbsp;&nbsp;
						<input
							type="radio"
							style={{ cursor: 'pointer' }}
							checked={!this.state.resolution900x900}
							onChange={() => { this.handleResolution(false) }}
						/>
						<span style={{ color: '#164289', fontSize: '1.2rem' }}> 300 x 300</span>
					</div>
				</Col>
				<Col xs={12} md={12} sm={12} lg={12} style={{ marginTop: "3vh" }} >
					<Dropzone
						inputContent="Arrastra las imágenes o da click aquí"
						getUploadParams={this.getUploadParams}
						onChangeStatus={this.handleChangeStatus}
						inputWithFilesContent="Agregar mas imágenes"
						submitButtonContent="Cargar Imagen(es)"
						onSubmit={this.handleSubmit}
						accept="image/*"
					/>

				</Col>
				{
					product_reducer.data.length > 0 &&
					<Col xs={12} sm={12} md={12} lg={12} style={{ marginTop: "35px" }} >
						<h2>Imágenes procesadas</h2>
						{
							product_reducer &&
							product_reducer.data &&

							<ToolkitProvider
								keyField="row_number"
								data={data}
								columns={columnsUpload}
								search={{ customMatchFunc }}
							>
								{
									props => (
										<div style={{ textAlign: "left", height: "300px", overflow: "auto", width: "100%" }}>
											<SearchBar
												placeholder={"Buscar"}
												{...props.searchProps}
												/>
											<hr />
											<BootstrapTable
												rowStyle={rowStyle}
												
												{...props.baseProps}
												/>
										</div>
									)
								}
							</ToolkitProvider>
						}
					</Col>
				}
				{
					<Col xs={12} sm={12} md={12} lg={12} style={{ marginTop: "25px", marginBottom: "10px" }} >
						<h2>Imágenes pendientes</h2>
						{
							<ToolkitProvider
								keyField = "no_sap"
								data     = {this.state.pendingImages}
								columns  = {columnsPending}
							//search={{ customMatchFunc }}
							>
								{
									props => (
										<div style={{ textAlign: "left", height: "400px", overflow: "auto", width: "100%" }}>
											<SearchBar
												placeholder={"Buscar"}
												{...props.searchProps}
											/>
											&nbsp;
											<button className="btn btn-primary" style={{ marginRight: "10px", height: "34px", marginTop: "-2px" }} onClick={this.onSearch}>
												<SearchOutlined style={{ fontSize: "20px" }} />
												<i className="glyphicon glyphicon-search"></i>
											</button>
											<button className="btn btn-default" style={{ marginRight: "10px", height: "34px", marginTop: "-2px" }} onClick={this.onRefresh}>
												<Refresh style={{ fontSize: "20px" }} />
											</button>
											<button className="btn btn-success" style={{ marginTop: "-6px" }} onClick={this.onDownloadReport}>Descargar CSV</button>
											<BootstrapTable
												striped
												hover
												condensed
												headerWrapperClasses="title-table"
												{...props.baseProps}
											/>
										</div>
									)
								}
							</ToolkitProvider>
						}
						{
							<div className="toolbar100 end" style={{ marginTop: "5px" }}>
								<button
									className={this.state.page !== 1 ? "modalButtonPager" : "modalButtonPager disabled"}
									onMouseDown={(e) => {
										e.preventDefault();
										this.setState({
											page: this.state.page - 1
										}, () => {
											this.getImages();
										});
									}}
									disabled={this.state.page === 1 ? true : false}
								>
									« Anterior
								</button>

								<button
									className={this.state.page < this.state.totalPendingImagesPages ? "modalButtonPager" : "modalButtonPager disabled"}
									onMouseDown={(e) => {
										e.preventDefault();
										this.setState({
											page: this.state.page + 1
										}, () => {
											this.getImages();
										});
									}}
									disabled={this.state.page < this.state.totalPendingImagesPages ? false : true}
								>
									Siguiente »
								</button>
							</div>
						}
					</Col>
				}
				{
					<ImageAuditModal
						imageAuditModalIsVisible = {this.state.imageAuditModalIsVisible}
						productImageSavedData    = {this.state.productImageSavedData}
						handleCancel             = {this.handleCancel}
					/>
				}
				{
					<LoadingOverlay
						active={this.state.activeLoader}
						isVisible={this.state.activeLoader}
						spinner
						text='Esto puede tardar unos minutos'
						styles={{
							wrapper: {
								width: this.state.activeLoader ? '100%' : '0%',
								height: this.state.activeLoader ? '100%' : '0%',
								overflow: 'hidden',
							},
							overlay: (base) => ({
								...base,
								background: 'rgba(10, 10, 10, 0.7)'
							})
						}}>
					</LoadingOverlay>
				}
				{
					<Snackbar
						open={this.state.showSnackBar}
						autoHideDuration={6000}
						onClose={this.handleCloseSnack}>
						<Alert
							onClose={this.handleCloseSnack}
							severity={this.state.severitySnackBar}>
							{this.state.textSnackBar}
						</Alert>
					</Snackbar>
				}
			</div>
		);
	}
}

const mapStateToProps = state => ({
	product_reducer: state.product_reducer,
	pendingImages: state.product_reducer.pendingImages,
	totalPendingImagesPages: state.product_reducer.totalPendingImagesPages,
	actionType: state.product_reducer.actionType,
	errors: state.errors,
	success: state.success
});

export default connect(
	mapStateToProps,
	{
		GetPendingImages,
		UploadImage,
		MarkAsCompleted,
		GetProductImageSavedData
	}
)(UploadProductImage);
